import { get } from 'lodash/fp';
import axios from './axios';
import config from '../../helpers/config';

export default designId => (
  axios.get(`${config.designBuilderLoadDesignPath}/${designId}`)
    .then(get('data'))
);

